var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4993 12.5007C32.4993 14.8018 30.6339 16.6673 28.3327 16.6673C26.0315 16.6673 24.166 14.8018 24.166 12.5007C24.166 10.1995 26.0315 8.33398 28.3327 8.33398C30.6339 8.33398 32.4993 10.1995 32.4993 12.5007Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 12.5007C7.50065 14.8018 9.36613 16.6673 11.6673 16.6673C13.9685 16.6673 15.834 14.8018 15.834 12.5007C15.834 10.1995 13.9685 8.33398 11.6673 8.33398C9.36613 8.33398 7.50065 10.1995 7.50065 12.5007Z",
    fill: "#84DCC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 27.5007C36.6673 29.8018 33.6825 31.6673 30.0007 31.6673C26.3188 31.6673 23.334 29.8018 23.334 27.5007C23.334 25.1995 26.3188 23.334 30.0007 23.334C33.6825 23.334 36.6673 25.1995 36.6673 27.5007Z",
    fill: "#84DCC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 27.5007C3.33268 29.8018 6.31745 31.6673 9.99935 31.6673C13.6812 31.6673 16.666 29.8018 16.666 27.5007C16.666 25.1995 13.6812 23.334 9.99935 23.334C6.31745 23.334 3.33268 25.1995 3.33268 27.5007Z",
    fill: "#84DCC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8327 12.4993C25.8327 15.721 23.221 18.3327 19.9993 18.3327C16.7777 18.3327 14.166 15.721 14.166 12.4993C14.166 9.27769 16.7777 6.66602 19.9993 6.66602C23.221 6.66602 25.8327 9.27769 25.8327 12.4993Z",
    fill: "#1177BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.4993C30 30.721 25.5228 33.3327 20 33.3327C14.4772 33.3327 10 30.721 10 27.4993C10 24.2777 14.4772 21.666 20 21.666C25.5228 21.666 30 24.2777 30 27.4993Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/registered.d5050c5f81674174d57442d7f4200e7b.svg";
export { ForwardRef as ReactComponent };